import { Box, IconButton } from '@mui/material';
import React from 'react';
import { useStores } from 'stores/storeInitializer';
import { Languages } from 'stores/store';
import { US, GR, RO } from 'country-flag-icons/react/3x2';
import { observer } from 'mobx-react';

const languageFlags = [
    { language: Languages.el, Flag: GR },
    { language: Languages.en, Flag: US },
    { language: Languages.ro, Flag: RO },
];

export const LanguageSwitch = observer(() => {
    const { store } = useStores();
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'absolute',
                top: 0,
                right: 0,
            }}
        >
            {languageFlags.map(({ language, Flag }) => (
                <IconButton
                    key={language}
                    disabled={store.language === language}
                    onClick={() => {
                        store.setAndRememberLanguage(language);
                    }}
                >
                    <Flag
                        style={{
                            height: '20px',
                            width: '20px',
                            opacity: store.language === language ? 1 : 0.5,
                        }}
                    />
                </IconButton>
            ))}
        </Box>
    );
});
